var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle-plus_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,70c0,2.209-1.791,4-4,4s-4-1.791-4-4V52H26c-2.209,0-4-1.791-4-4s1.791-4,4-4h18V26c0-2.209,1.791-4,4-4s4,1.791,4,4v18 h18c2.209,0,4,1.791,4,4s-1.791,4-4,4H52V70z M10.097,48c0-18.222,13.002-33.882,30.916-37.237l3.264-0.611V1.917l-4.732,0.88 C17.79,6.846,2,25.856,2,48c0,22.145,15.79,41.154,37.544,45.202l4.732,0.88v-8.234l-3.264-0.611 C23.099,81.882,10.097,66.222,10.097,48z M56.456,2.798l-4.731-0.88v8.234l3.264,0.611C72.901,14.118,85.903,29.778,85.903,48 S72.901,81.882,54.988,85.236l-3.264,0.611v8.234l4.731-0.88C78.211,89.154,94,70.144,94,48C94,25.855,78.211,6.845,56.456,2.798z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.5396ccd0ca689326ba6cfa920c497e26.svg";
export { ForwardRef as ReactComponent };